var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-3 d-flex align-items-center justify-content-center"},[_c('b-spinner',{staticClass:"loading-spinner"}),_c('div',{staticClass:"loading-text ml-2"},[_vm._t("default",[_vm._v("Loading...")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }